import { ProductDto } from "@custom-types/products"
import { Chip, Stack, Tooltip } from "@mui/material"

type ProductLabelProps = {
  product: ProductDto | undefined
}

const ProductLabel = ({ product }: ProductLabelProps) => {
  if (!product) return <></>

  return (
    <Stack direction="row" gap={1}>
      <Tooltip title="Organisation" placement="top" sx={{ bgcolor: "#1b5e20", color: "#ffffff" }}>
        <Chip label={product.organisation_key} />
      </Tooltip>

      <Tooltip title="Division" placement="top" sx={{ bgcolor: "#e65100", color: "#ffffff" }}>
        <Chip label={product.division_key} />
      </Tooltip>

      <Tooltip title="Product" placement="top" sx={{ bgcolor: "#01579b", color: "#ffffff" }}>
        <Chip label={product.key} />
      </Tooltip>
    </Stack>
  )
}

export default ProductLabel
